export { default } from "./QuestionFlagContainer";
